var t=function(t){var e=t.placement,r=t.reference;switch(e){case"top-start":case"bottom-start":return[r.width/2-22,12];case"top-end":case"bottom-end":return[-r.width/2+22,12];default:return[0,12]}};export{t as getTooltipOffset};
